import { Component, Input, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'app-checkbox-group',
  templateUrl: './checkbox-group.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CheckboxGroupComponent),
      multi: true,
    },
  ],
})
export class CheckboxGroupComponent implements ControlValueAccessor {
  @Input() options = Array<any>();
  @Input() inline = false;
  @Input() disabled = false;
  @Input() disabledItems = [];
  @Input() allSelectable: boolean = false;

  private _model: any;
  private onChange: (m: any) => void;
  private onTouched: (m: any) => void;

  get model() {
    return this._model;
  }

  public writeValue(value: any): void {
    this._model = Array.isArray(value) ? value : [];
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  set(value: any) {
    this._model = value;
    this.onChange(this._model);
  }

  toggleCheck(value) {
    if (!Array.isArray(this._model)) this._model = [];
    if (this.isChecked(value)) {
      const index = this._model.indexOf(value);
      if (index < 0) return;
      this._model.splice(index, 1);
      this.onChange(this._model);
    } else {
      this._model.push(value);
      this.onChange(this._model);
    }
  }

  isChecked(value: string): boolean {
    if (this._model instanceof Array) {
      return this._model.indexOf(value) > -1;
    } else if (!!this._model) {
      return this._model === value;
    }
    return false;
  }

  isDisabled(value: string): boolean {
    if (this.disabledItems.findIndex((item) => (this.getValue(item) == value)) === -1) return false;
    return true;
  }

  getValue(option): string {
    if (option instanceof Object) {
      return option.id || option.value;
    }
    return option;
  }

  getLabel(option): string {
    if (option instanceof Object) {
      return option.label || option.text || option.name || option.value || option.id;
    }
    return option;
  }

  selectAll() {
    if (!Array.isArray(this._model)) this._model = [];
    if (!this.options || !this.options.length) return;
    const allValues = this.options.map((option) => this.getValue(option));
    if (this._model.length < allValues.length) {
      this._model = allValues;
    } else {
      this._model = [];
    }
    this.onChange(this._model);
  }

  isAllChecked() {
    if (!this._model || !Array.isArray(this._model) || !this.options || !this.options.length) return false;
    const allValues = this.options.map((option) => this.getValue(option));
    return this._model.length === allValues.length;
  }
}
